import type { ReactNode } from 'react';

import type { TRichTextElement } from '@shared/dream-components';
import { RichTextElement } from '@shared/dream-components';

import usePodcastMergeTagProcessor from './hooks/usePodcastMergeTagProcessor';
import useProductMergeTagProcessor from './hooks/useProductMergeTagProcessor';

interface Props {
  node: TRichTextElement;
  children: ReactNode | ReactNode[];
}

const RichText = ({ node, children }: Props) => {
  const { children: childrenToRenderPodcast, node: nodeToRenderPodcast } = usePodcastMergeTagProcessor({
    node,
    children,
  });
  const { node: processedNode, children: childrenToRender } = useProductMergeTagProcessor({
    node: nodeToRenderPodcast,
    children: childrenToRenderPodcast,
  });

  return <RichTextElement element={processedNode as TRichTextElement}>{childrenToRender}</RichTextElement>;
};

export default RichText;
